import { createAction, props } from '@ngrx/store';
import {
  DataModuleEntity,
  DataModuleEntityId,
  DataModuleName,
  DataStartedAt,
} from '@edgvr-front/data/domain';

export const init = createAction('[Data Module / Modules List Page] Init');
export const destroy = createAction(
  '[Data Module / Modules List Page] Destroy'
);

export const dataModulesList = createAction(
  '[Data Module / Modules List Page] Data Modules List',
  props<{
    page: number;
    moduleName?: DataModuleName;
    from?: DataStartedAt;
    to?: DataStartedAt;
  }>()
);
export const dataModulesListSuccess = createAction(
  '[Data Module / Modules List Page] Data Modules List Success',
  props<{ dataModules: DataModuleEntity[]; count: number; page: number }>()
);
export const dataModulesListFailure = createAction(
  '[Data Module / Modules List Page] Data Modules List Failure'
);
